// type Props = {
//     label: string;
//     options: SelectOption[];
//     required?: boolean;
// };

import { Checkbox, FormControlLabel } from "@mui/material"
import { FieldRenderProps } from "react-final-form";
import { GenericInputProps } from "../types";

export type CheckboxFieldProps = FieldRenderProps<GenericInputProps, any>;

const CheckboxField: React.FC<CheckboxFieldProps> = ({ input, meta, loading, helperText, ...props }) => {
    const { showIf, label, ...reset } = props;
    return (
        <FormControlLabel
            labelPlacement="start"
            label={label}
            sx={{ width: "minContent" }}
            control={<Checkbox
                {...input}
                {...reset}
                value={input.value ?? meta.initial}
            />}
        />
    )
}
export default CheckboxField
